module.exports = __webpack_public_path__ + "static/money-5face66f953c29b3f9ff0d1defa6496c.jpg";